import { VFC } from 'react';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi2';

export type SortToggleProps = {
  isSorted: boolean;
  isSortedDesc?: boolean;
};

const SortToggle: VFC<SortToggleProps> = ({ isSorted, isSortedDesc }) => {
  if (!isSorted) {
    return null;
  }

  if (isSortedDesc) {
    return <HiChevronDown className="h-4" />;
  }

  return <HiChevronUp className="h-4" />;
};

export default SortToggle;
